var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConverterSelc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh-cw (1) 1",
    clipPath: "url(#clip0_7207_1395)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.5 4.67432V10.6743H17.5",
    stroke: "#3A68D8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.5 20.6743V14.6743H7.5",
    stroke: "#3A68D8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.01 9.67427C4.51717 8.24106 5.37913 6.95967 6.51547 5.94969C7.6518 4.9397 9.02547 4.23404 10.5083 3.89853C11.9911 3.56302 13.5348 3.60861 14.9952 4.03104C16.4556 4.45348 17.7853 5.23898 18.86 6.31427L23.5 10.6743M1.5 14.6743L6.14 19.0343C7.21475 20.1096 8.54437 20.8951 10.0048 21.3175C11.4652 21.7399 13.0089 21.7855 14.4917 21.45C15.9745 21.1145 17.3482 20.4088 18.4845 19.3989C19.6209 18.3889 20.4828 17.1075 20.99 15.6743",
    stroke: "#3A68D8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7207_1395"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.674316)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConverterSelc);
export default __webpack_public_path__ + "static/media/ConverterSelc.b8ae78d06a8e24016f58ff5201eda34b.svg";
export { ForwardRef as ReactComponent };